export const stopServer = () => {
    console.log("Stopping Server...");
    return "Stopping Server..."
}
